import { extractYoutubeId } from "../../Objects/Generics/Helps"

interface LandingYoutubeFrameProps {
  youtubeUrl?: string | null
  title: string
  aspectRatio?: string
  frameWrapperClassName?: string
}

const LandingYoutubeFrame = ({
  youtubeUrl,
  title,
  aspectRatio = "16 / 9",
  frameWrapperClassName = "",
}: LandingYoutubeFrameProps) => {
  const videoId = extractYoutubeId(youtubeUrl ?? "")

  if (!videoId) {
    return null
  }

  const src = `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&loop=1&playlist=${videoId}&rel=0&playsinline=1`

  return (
    <div className="rounded-3xl border border-slate-200 bg-white p-4 shadow-sm">
      <div
        className={`overflow-hidden rounded-lg border border-slate-100 bg-slate-50 w-full ${frameWrapperClassName}`}
        style={{ aspectRatio }}
      >
        <iframe
          title={title}
          src={src}
          className="h-full w-full"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
        />
      </div>
    </div>
  )
}

export default LandingYoutubeFrame
